import * as yup from "yup";

const schema = yup
    .object()
    .shape({
      config: yup
        .array()
        .of(
          yup
            .number()
            .min(180, "Minimum 180 seconds or 3 minutes")
            .typeError("Active chat weight must be a number")
            .required("Inactive chat weight is required")
        ),
    })
    .required();

export default schema;